/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StocktakePrepareService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async SaveStocktake(payload) {
    var url = `api/Save_PrepareStocktake`;
    return await ApiService.post(url, payload);
  },

  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },


  async getStockTakeListItemById(code, select) {
    const requestScreenData = {
      url: "api/StocktakeList",
      top: "1",
      filter: `Code eq ${code}`,
    };

    if (select) requestScreenData.select = select;
    return await ApiService.oDataGet(requestScreenData);
  },

  async getStocktakeBranch(code) {
    const requestScreenData = {
      url: "api/StocktakeBranch",
      filter: `StocktakeCode eq ${code}`,
      sort: [{ selector: "BranchDescription", asc: true }],
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async setLineExclude(payload) {
    var url = `api/Save_StocktakeExcludeProducts`;
    return await ApiService.post(url, payload);
  }

};

export { StocktakePrepareService };
